import {backupFilter, Filter, FilterExt, getFilterUrl, restoreFilter} from "./structs/Filter";
import {Api} from "./Api";
import {SearchData} from "./structs/SearchData";
import {Kachel, kachelToHtml} from "./structs/Kachel";
import {SearchForm} from "./SearchForm";
import {SearchMap} from "./maps/SearchMap";

export class Search {
    static filter: Filter = null;
    static filterExt: FilterExt = null;
    static resultCache: { [key: string]: SearchData } = {};
    static kacheln: Kachel[] = [];

    private static _parsePageNumber(url: string): number {
        const m = url.match(/page-(\d+)\//);
        return m ? parseInt(m[1]) : 1;
    }

    private static _replacePageButtons() {
        const els = <HTMLAnchorElement[]><any>($(".pagination li a[href]"));
        for (let i = 0; i < els.length; i++) {
            const pageNumber = Search._parsePageNumber(els[i].href);
            $(els[i]).on("click", () => {
                Search.updateSearch(null, pageNumber);
                return false;
            });
        }
    }

    private static _displayPage(sc: SearchData, skipHistory?: boolean) {
        $("#header-searchbar").val(sc.search_term);
        $("h1.search-result-header").html('<span class="brand-primary-1-text h3">' + sc.result_count + '</span> <strong>' + sc.txt_sr_results + ' - <span>' + sc.search_term + '</span></strong>');

        let html = "";
        Search.kacheln = sc.kacheln;
        sc.kacheln.forEach(k => {
            html += kachelToHtml(k);
        })
        $("#search-results-panel > div.search-results > div.search-results-container > div.row").html(html);

        $(".search-results-count > .brand-primary-1-text").html(sc.page_selected.toString());
        $(".search-results-count > span").html(sc.page_total.toString());
        const PageNumberButtons = 5;
        html = "";

        if (sc.page_selected > 1) {
            html += '<li><a href="' + Search.getFilterUrl(1) + '"><i class="glyphicon glyphicon-backward"></i></a></li>';
            html += '<li class="prev hidden-xs"><a href="' + Search.getFilterUrl(sc.page_selected - 1) + '"><i class="glyphicon glyphicon-triangle-left"></i></a></li>';
            html += '<li class="prev visible-xs-inline"><a href="' + Search.getFilterUrl(sc.page_selected - 1) + '"><i class="glyphicon glyphicon-triangle-left"></i></a></li>';
        }

        let start = sc.page_selected - (PageNumberButtons >> 1);
        if (start < 1) start = 1;
        let end = sc.page_selected + (PageNumberButtons >> 1);
        for (; end - start < PageNumberButtons - 1;) end++;
        if (end > sc.page_total) end = sc.page_total;
        for (; end - start < PageNumberButtons - 1;) start--;
        if (start < 1) start = 1;
        for (let i = start; i <= end; i++) {
            html += '<li' + (i == sc.page_selected ? ' class="active"' : '') + '><a href="' + Search.getFilterUrl(i) + '">' + i + '</a></li>'
        }

        if (sc.page_selected < sc.page_total) {
            html += '<li class="next hidden-xs"><a href="' + Search.getFilterUrl(sc.page_selected + 1) + '"><i class="glyphicon glyphicon-triangle-right"></i></a></li>';
            html += '<li class="next visible-xs-inline"><a href="' + Search.getFilterUrl(sc.page_selected + 1) + '"><i class="glyphicon glyphicon-triangle-right"></i></a></li>';
            html += '<li><a href="' + Search.getFilterUrl(sc.page_total) + '"><i class="glyphicon glyphicon-forward"></i></a></li>';
        }

        $(".pagination").html(html);
        Search._replacePageButtons();
        SearchForm.reset();
        SearchMap.updateMarker(Search.kacheln);

        if (!skipHistory) {
            Search._updateUrl(sc.full_path);
            $('#apply-bar .apply-filters-btn').prop('disabled', location.href === Search.backupUrl);
        }
    }

    static getFilterUrl(pageNumber?: number) {
        return getFilterUrl(Search.filter, pageNumber);
    }

    private static _updateUrl(url: string) {
        if (url.indexOf(document.location.origin) == 0) url = url.substring(document.location.origin.length);
        console.log("seturl", url)
        history.pushState({}, '', url);
    }

    private static _startSearchUrl(url: string, callback?: (data: SearchData) => void) {
        if (Search.resultCache[url]) {
            if (callback) callback(Search.resultCache[url]);
            return
        }
        Api.searchData(url, d => {
            if (d.page_selected > 0) {
                Search.resultCache[url] = d
                if (callback) callback(d);
            }
        })
    }

    static updateSearch(callback?: (data: SearchData) => void, pageNumber?: number) {
        Search._startSearchUrl(getFilterUrl(Search.filter, pageNumber), sc => {
            Search._displayPage(sc);
            if (callback) callback(sc);
        });
    }

    static init() {
        Search.filter = window.filterJson;
        Search.filterExt = window.filterExtJson;

        $(() => {
            console.log("init search");

            Search._startSearchUrl(window.location.pathname, sc => {
                Search.kacheln = sc.kacheln;

                window.addEventListener('popstate', () => {
                    console.log('change url', window.location.pathname);
                    Search.openFilters(false);
                    Search._startSearchUrl(window.location.pathname, sc => Search._displayPage(sc, true))
                });

                SearchForm.init(Search.filter, () => {
                    Search.updateSearch();
                });

                $("#additional-search-filters>button").on("click", () => Search.openFilters($("#apply-bar").is(":hidden")));
                $("#apply-bar .cancel-btn").on("click", () => {
                    if (Search.backupUrl && Search.backupUrl != location.href) {
                        restoreFilter(Search.filter, Search.backupFilter);
                        Search._startSearchUrl(Search.backupUrl, sc => {
                            Search._displayPage(sc);
                        })
                    }
                    Search.openFilters(false);
                });
                $('#apply-bar .apply-filters-btn').on("click", () => Search.openFilters(false));
                Search._replacePageButtons();
                SearchForm.reset();

                SearchMap.initMap();
            })
        });
    }

    static backupUrl: string = "";
    static backupFilter: string;

    static openFilters(open: boolean) {
        if (open) {
            $("#search-results-panel").hide();
            $("#apply-bar,#filter-extended").show();
            $('#apply-bar .apply-filters-btn').prop('disabled', true);
            Search.backupUrl = Search.getFilterUrl(Search._parsePageNumber(location.pathname));
            Search.backupFilter = backupFilter(Search.filter);
        } else {
            $("#search-results-panel").show();
            $("#apply-bar,#filter-extended").hide();
            Search.backupUrl = "";
            Search.backupFilter = "";
        }
    }
}
